import { createSelector } from 'reselect';
import jwtDecode from 'jwt-decode';

const getToken = state => state.auth.token;

const getDecodedToken = createSelector(
  getToken,
  token => {
    if (token) {
      return jwtDecode(token);
    }
    return {};
  }
);

const getAuthenticatedAccountId = createSelector(
  getDecodedToken,
  decodedToken => decodedToken.accountId
);

const getAuthenticatedProfileId = createSelector(
  getDecodedToken,
  decodedToken => decodedToken.profileId
);

const getAuthenticatedIsAdmin = createSelector(
  getDecodedToken,
  decodedToken => decodedToken.isAdmin
);

const getAuthenticatedIsStaff = createSelector(
  getDecodedToken,
  decodedToken => decodedToken.isStaff
);

const getSelectedProfileId = state => state.auth.profile;
const getEditingProfileId = state => state.auth.editingProfile;

export {
  getToken,
  getAuthenticatedAccountId,
  getAuthenticatedProfileId,
  getAuthenticatedIsAdmin,
  getAuthenticatedIsStaff,
  getSelectedProfileId,
  getEditingProfileId
};



// WEBPACK FOOTER //
// ./src/selectors/auth.js